import React, { useEffect, useRef, useState } from 'react';
import floatingPerson from './assets/footer-vector.png';
import './css/Footer.css';

const links = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/shruti-sharma-1b1b131a6/', cmd: 'open --social linkedin' },
  { label: 'GitHub', href: 'https://github.com/sj056', cmd: 'open --repo github' },
  { label: 'Unstop', href: 'https://unstop.com/mentor/shrutisharma?ref=b5cYgnmt', cmd: 'open --mentor unstop' },
  { label: 'Topmate', href: 'https://topmate.io/iamshruti', cmd: 'open --book topmate' },
];

const Footer = () => {
  const [visible, setVisible] = useState(false);
  const [glitching, setGlitching] = useState(false);
  const [linesDone, setLinesDone] = useState(0);
  const footerRef = useRef(null);

  // Scroll reveal
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (footerRef.current) obs.observe(footerRef.current);
    return () => obs.disconnect();
  }, []);

  // Stagger link lines appearing
  useEffect(() => {
    if (!visible) return;
    links.forEach((_, i) => {
      setTimeout(() => setLinesDone(i + 1), 900 + i * 280);
    });
  }, [visible]);

  // Random glitch bursts on the headline
  useEffect(() => {
    if (!visible) return;
    const burst = () => {
      setGlitching(true);
      setTimeout(() => setGlitching(false), 200 + Math.random() * 180);
    };
    const schedule = () => {
      const delay = 3000 + Math.random() * 5000;
      return setTimeout(() => { burst(); schedule(); }, delay);
    };
    const t = schedule();
    return () => clearTimeout(t);
  }, [visible]);

  return (
    <>
      <footer
        id="footer"
        ref={footerRef}
        className={`footer-root ${visible ? 'visible' : ''}`}
      >
        {/* Stars */}
        <div className="footer-stars">
          {Array.from({ length: 60 }).map((_, i) => (
            <div
              key={i}
              className="footer-star"
              style={{
                width: `${1 + Math.random() * 2}px`,
                height: `${1 + Math.random() * 2}px`,
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 4}s`,
                animationDuration: `${3 + Math.random() * 4}s`,
              }}
            />
          ))}
        </div>

        {/* Ambient glows */}
        <div className="footer-glow footer-glow-1" />
        <div className="footer-glow footer-glow-2" />

        {/* Scanlines */}
        <div className="footer-scanlines" />

        {/* ── Headline ── */}
        <div className="footer-headline-wrap">
          <h2
            className={`footer-headline ${glitching ? 'glitch' : ''}`}
            data-text="Thanks for visiting!"
          >
            Thanks for visiting!
          </h2>
          <div className="footer-transmission">
            transmission end · signal received
          </div>
        </div>

        {/* ── Content ── */}
        <div className="footer-content">

          {/* Terminal */}
          <div className="footer-terminal">
            <div className="footer-terminal-header">
              // establish connection
            </div>
            <div className="footer-tagline">
              Let's build something meaningful —
            </div>

            {links.map((link, i) => (
              <div
                key={link.label}
                className={`footer-link-row ${linesDone > i ? 'show' : ''}`}
                style={{ transitionDelay: `${i * 0.05}s` }}
              >
                <span className="footer-link-prompt">›</span>
                <span className="footer-link-cmd">{link.cmd}</span>
                <a
                  href={link.href}
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link-a"
                >
                  {link.label}
                </a>
                {/* cursor blinks on the last revealed line */}
                {linesDone === i + 1 && linesDone < links.length && (
                  <span className="footer-link-cursor" />
                )}
              </div>
            ))}
          </div>

          {/* Floating person */}
          <img
            src={floatingPerson}
            alt="Shruti Sharma"
            className="footer-person"
          />
        </div>

        {/* ── Bottom bar ── */}
        <div className="footer-bottom">
          <a href="mailto:iamshrutisharma056@gmail.com" className="footer-email">
            shrutisharma6501@gmail.com
          </a>
          <div className="footer-made">
            Made with <span>❤</span> by Shruti Sharma
          </div>
        </div>

      </footer>
    </>
  );
};

export default Footer;